
import Vue from 'vue';
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import Card from '@/components/Card/index.vue';
import HeaderInternal from '@/components/HeaderInternal/index.vue';
import Accordion from '@/components/Accordion/index.vue';
import 'vue-simple-accordion/dist/vue-simple-accordion.css';
import Tag from '@/components/Tag/index.vue';
import getTerritoryByCarCodeService from '@/services/territory/get-territory-by-car-code';
import getTerritoryByIdService from '@/services/territory/get-territory-by-id';
import apiGixget from '@/services/appoinments/get-gix';
import { actAndAppoitmentGetAll, ActAndAppoitmentGetAllParams } from '@/services/act/act-get-all';
import { actCreate, ActCreateParams } from '@/services/act/act-create';
import { capitalizeFirstLetter } from '@/utils/capitalize-first-letter';
import getTerritoryPenaltyStatus from '@/services/territory/get-territory-penalty-status';
import { TerritoryPenaltyStatus, TerritoryPenaltyStatusEnum } from '@/config/types';
import {
  getAppointment as getAppointmentRequest,
} from '@/services/territory/get-appointment';
import { getLinkTermCommitmentbyCdAgentCarNumber } from '@/services/term-commitment/get-document-by-cd-agent-car-number';
import { getUserGroup } from '@/utils';
import { actPdfCreate, ActPdfParams } from '@/services/act/get-link-document-act';
import constants from '@/config/constants';
import { GetReportParms, getReport } from '@/services/territory/get-report';
import getPenalty from '@/services/tickets/get-penalty';
import getTickets from '@/services/tickets/get-tickets';
import getAct from '@/services/act/get-act';
import {
  Container, Main, Wrapper,
} from './styles';

export default Vue.extend({
  props: ['id'],
  components: {
    Card,
    Container,
    HeaderInternal,
    Main,
    Tag,
    Accordion,
    Wrapper,
  },
  data() {
    return {
      visibleModal: true,
      territoryEditionModal: false,
      penaltyPageButton: false,
      dataPenalty: {} as any,
      actArray: [] as any[],
      territory: {
        loaded: false,
        territoryEditionModal: false,
        agents: [
          {
            id: '',
          },
        ],
        city: '',
        state: '',
        name: '',
        car: '',
        id: '',
        documents: [],
      } as any,
      qrCode: '',
      month: 0,
      actDataResult: [] as any[],
      actData: {} as any,
      territoryPenaltyStatus: {} as TerritoryPenaltyStatus,
      gixData: {} as any,
      statusFlag: {} as TerritoryPenaltyStatus,
      linkActPdf: '',
      userLoged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      territoryArray: [] as any[],
      objAct: {} as any,
      dataCdTerritory: {
        cdTerritory: '',
      } as any,
      tickets: {} as any,
      headerColumns: ['Tipo', 'Data de Inicio', 'Fim do prazo', 'Status', 'Resultado'],
      headerColumnsAct: ['Nome', 'Data de Inicio', 'Fim do prazo', 'PDF'],
      headerColumnsTickets: ['Nome', 'Data de vencimento', 'Status', 'QR Code (PIX)', 'Boleto'],
      headerColumnsDocs: ['Nome', 'PDF'],
      territoryByCar: {
        loaded: false,
        aderiuPRA: '',
        area: '',
        dataAnalise: '',
        dataRegistro: '',
        dataRetificacao: '',
        latitude: '',
        longitude: '',
        modulosFiscais: '',
        statusImovel: '',
        condicaoAnalise: '',
        estado: '',
      } as any,
      termSocioEnvironmental: {
        type: 'termSocioEnvironmental',
      } as any,
      docsLink: [] as any[],
      termCommitment: 'nulo',
      loading: false,
      actLoaded: false,
    };
  },
  computed: {
    ...mapGetters(['DateById', 'DateAct']),
    getAppointment(): any[] {
      return this.actArray.map((appointment) => {
        const dateStart = moment(appointment.dtAppointment || appointment.createdOn);
        const dataInicioAct = moment(appointment.act).subtract(1, 'months').format('L');
        const dateEnd = appointment.dtAppointment
          ? moment(appointment.dtAppointment).add(7, 'days')
          : moment(appointment.act);
        const diff = dateEnd.diff(appointment.dtAppointment, 'months');
        if (diff < 3) {
          return {
            type: appointment?.type?.type || 'ACT',
            dtAppointment: dateStart.format('L'),
            dtEnd: dateEnd.format('L'),
            dataAct: dataInicioAct,
            status: appointment.status || 'Em andamento',
            result: 'Aprovado',
          };
        } if (diff === 6) {
          return {
            type: appointment?.type?.type || 'ACT',
            dtAppointment: dateStart.format('L'),
            dtEnd: dateEnd.format('L'),
            dataAct: dateEnd.subtract(3, 'months').format('L'),
            status: appointment.status || 'Em andamento',
            result: 'Aprovado',
          };
        } if (diff === 3) {
          return {
            type: appointment?.type?.type || 'ACT',
            dtAppointment: dateStart.format('L'),
            dtEnd: dateEnd.format('L'),
            dataAct: dataInicioAct,
            status: appointment.status || 'Em andamento',
            result: 'Aprovado',
          };
        }
        return {
          type: appointment?.type?.type || 'ACT',
          dtAppointment: dateStart.format('L'),
          dtEnd: dateEnd.format('L'),
          dataAct: dateEnd.subtract(6, 'months').format('L'),
          status: appointment.status || 'Em andamento',
          result: 'Aprovado',
        };
      })
        .sort((date1, date2) => this.IsEqualDate(date1.dtAppointment, date2.dtAppointment));
    },
  },
  methods: {
    ...mapActions({ getAppointmentDate: 'getAppointmentDate' }),
    IsEqualDate(date1: string, date2: string) {
      return moment(date1, 'DD/MM/YYYY').unix() - moment(date2, 'DD/MM/YYYY').unix();
    },
    async getTerritoryById() {
      /* eslint max-len: ["error", { "code": 130 }] */
      const { id } = this.$route.params;

      const response = await getTerritoryByIdService(id);
      if (response.hasErrors) this.$router.push('/not-found');

      this.territory = response.objectResult;

      this.territory.loaded = true;

      if (this.isAdminUser()) {
        this.territoryPenaltyStatus = await this.getTerritoryPenaltyStatus(id);
      }

      let documentCAR;

      if (response.objectResult.documents) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.territory.documents.forEach((document: any, index) => {
          if (document.type === 'TERCOM') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (this as any).territory.documents[index].title = document.title !== '' ? document.title : this.$t('terms');
          }
        });
        documentCAR = response.objectResult.documents.find(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (document: any) => document.type.includes('CARDOC'),
        );
      }

      if (documentCAR) {
        this.territory.car = documentCAR.title;
        this.getTerritoryByCarCode(this.territory.car);
      } else {
        this.territoryByCar.loaded = true;
      }
    },
    openPix() {
      this.$router.push(`/paypix/${this.$route.params.id}`);
    },
    payPix(value) {
      // @ts-ignore
      this.territoryEditionModal = true;
      this.visibleModal = true;
      this.qrCode = value;
    },
    close() {
      // @ts-ignore
      this.territoryEditionModal = false;
      this.visibleModal = false;
    },
    async appointmentRequest() {
      const params: ActAndAppoitmentGetAllParams = {
        cdTerritory: this.id,
        tokenKey: this.userLoged.company.stKey,
        agentId: this.territory.agents[0].id,
      };
      getAppointmentRequest(params).then((data) => this.territoryArray.push(...data));
      await actAndAppoitmentGetAll(params).then((resp) => {
        this.territoryArray = resp.data;
        const reduced = [] as any;
        this.territoryArray.forEach((item: any) => {
          const duplicated = reduced.findIndex((redItem: any) => item?.act === redItem?.act) > -1;
          const otherDate = reduced.findIndex(() => item.car === null) > -1;
          if (!duplicated || otherDate) {
            reduced.push(item);
          }
        });
        this.actArray = reduced;
        this.gixData.then((result) => {
          this.objAct = result.data.objectResult;
          for (let i = 0; i < this.objAct.length; i += 1) {
            if (
              this.objAct[i].dtJourneyFirstTaskStart !== null
              && this.objAct[i].cdTerritory === resp.data[0].cdTerritory
            ) {
              const dt = new Date(this.objAct[i].dtJourneyFirstTaskStart);
              dt.setDate(dt.getDate() + 7);
              const formated = moment(dt).format('YYYY-MM-DD');
              this.month = dt.getMonth() + 1;
              if (this.month === 12 || this.month === 1 || this.month === 2 || this.month === 3) {
                if (resp.hasAct) {
                  const data: ActCreateParams = {
                    territoryId: this.id,
                    tokenKey: this.userLoged.company.stKey,
                    dtAutovistory: formated,
                    score: this.objAct[i]?.journeyTaskQuizAnswerGroup[0]?.stScore,
                    period: 'Chuvoso',
                  };
                  actCreate(data);
                }
              } else if (
                this.month === 6
                || this.month === 7
                || this.month === 8
                || this.month === 9
              ) {
                if (resp.hasAct) {
                  const data: ActCreateParams = {
                    territoryId: this.id,
                    tokenKey: this.userLoged.company.stKey,
                    dtAutovistory: formated,
                    score: this.objAct[i]?.journeyTaskQuizAnswerGroup[0]?.stScore,
                    period: 'Seco',
                  };
                  actCreate(data);
                }
              } else if (
                this.month === 4
                || this.month === 5
                || this.month === 10
                || this.month === 11
              ) {
                if (resp.hasAct) {
                  const data: ActCreateParams = {
                    territoryId: this.id,
                    tokenKey: this.userLoged.company.stKey,
                    dtAutovistory: formated,
                    score: this.objAct[i]?.journeyTaskQuizAnswerGroup[0]?.stScore,
                    period: 'transição',
                  };
                  actCreate(data);
                }
              }
            }
          }
        });
      });
      this.updateStatusAct();
      this.actLoaded = true;
    },
    goToGeo(dataType: string, dataInitial: string, dataEnd: string) {
      if (dataType === 'Geomonitoramento') {
        this.$router.push({
          name: 'Geomonitoramento',
          params: { dataStart: dataInitial, dataEnd },
        });
        return;
      }

      if (dataType === 'Autovistoria') {
        this.$router.push({ name: 'Autovistoria', params: { dataStart: dataInitial, dataEnd } });
      }
    },
    async updateStatusAct() {
      for (let i = 0; i < this.territoryArray.length; i += 1) {
        if (
          this.territoryArray[i].act
          && this.territoryArray[i].act === this.territory.actCurrent.act
        ) {
          this.territoryArray[i].status = 'ativo';
        }
      }
    },
    goToPenaltyPage() {
      const documentData = this.userLoged.stDocument;
      const installments = this.dataPenalty[0].totalInstallments;
      const paymentValue = this.dataPenalty[0].totalAmount;
      const { id } = this.territory;
      this.$router.push({
        name: 'PaymentPay',
        params: {
          paymentValue, installments, documentData, id,
        },
      }, () => {
        Vue.$toast.success('Operação realizada com exito!');
      });
    },
    async getTerritoryByCarCode(carCode: string) {
      const { objectResult } = await getTerritoryByCarCodeService(carCode);

      if (objectResult) this.territoryByCar = objectResult.dadosExtratoPdf;

      this.territoryByCar.loaded = true;
    },
    async verifyPenalty() {
      const { id } = this.$route.params;
      this.statusFlag = await this.getTerritoryPenaltyStatus(id);
    },
    async getReportRequest() {
      const params: GetReportParms = {
        cdUser: this.userLoged.idUser,
        tokenKey: this.userLoged.company.stKey,
        cdTerritory: this.territory.id,
      };
      await getReport(params).then((data) => {
        this.termSocioEnvironmental = { ...this.termSocioEnvironmental, ...data };
      });
    },
    isAdminUser() {
      return getUserGroup() === constants.roles.admin;
    },
    getTerritoryPenaltyStatus(territoryId: string) {
      return getTerritoryPenaltyStatus(territoryId);
    },
    displayPenaltyPageButton() {
      return (
        this.isAdminUser() && this.territoryPenaltyStatus.id === TerritoryPenaltyStatusEnum.pending
      );
    },
    async actCreatePdf(dataInitial: string, dataEnd: string) {
      this.loading = true;
      const params: ActPdfParams = {
        tokenKey: this.userLoged.company.stKey,
        carNumber: this.territory.car,
        cdAgent: this.territory.agents[0].id,
        validityDateACT: moment(dataEnd).format('DD/MM/YYYY'),
        issueDateACT: moment(dataInitial).format('DD/MM/YYYY'),
        // @ts-ignore
        territoryName: this.territory.name,
        city: this.territory.city,
        state: this.territoryByCar.estado,
      };
      const response = await actPdfCreate(params);

      window.open(response.objectResult, '_blank');
      // @ts-ignore
      this.loadding = false;
    },
    getDocKey(): object {
      return {
        tercom: 'Termo de compromisso',
        termsocioenvironmental: 'Analise socioambiental',
      };
    },
    getDocs(): any[] {
      return [...this.territory.documents, this.termSocioEnvironmental]
        .map((doc) => {
          const docName = this.getDocKey[doc.type?.toLocaleLowerCase()];

          if (docName) {
            return {
              name: capitalizeFirstLetter(docName),
              url: doc.url || doc.urlExtract,
            };
          }
          return null;
        })
        .filter(Boolean);
    },
    convertDateActsArray() {
      for (let i = 0; i < this.actData.objectResult.length; i += 1) {
        this.actData.objectResult[i].act = moment(this.actData.objectResult[i].act).format(
          'DD/MM/YYYY',
        );
        this.actData.objectResult[i].dtAutovistory = moment(
          this.actData.objectResult[i].dtAutovistory,
        ).format('DD/MM/YYYY');
      }
    },
    convertDataTicketsArray() {
      for (let i = 0; i < this.tickets.objectResult.length; i += 1) {
        this.tickets.objectResult[i].dueDate = moment(this.tickets.objectResult[i].dueDate).format(
          'DD/MM/YYYY',
        );
        if (this.tickets.objectResult[i].status === 'payed') {
          this.tickets.objectResult[i].status = 'Pago';
        } else if (this.tickets.objectResult[i].status === 'pending') {
          this.tickets.objectResult[i].status = 'Pendente';
        } else if (this.tickets.objectResult[i].status === 'cancelled') {
          this.tickets.objectResult[i].status = 'Cancelado';
        }
      }
    },
    async getLinkDocumentTermCommitment() {
      const response = await getLinkTermCommitmentbyCdAgentCarNumber(
        this.userLoged.company.stKey,
        this.territory.agents[0].id,
        this.territory.car,
      );
      this.termCommitment = response.objectResult;
    },
    openDocumentPdf(url: string) {
      this.loading = true;
      window.open(url, '_blank');
      this.loading = false;
    },
  },
  async mounted() {
    // @ts-ignore
  },
  async created() {
    // @ts-ignore
    await this.getTerritoryById();
    this.getReportRequest();
    const { idUser } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');
    const { company } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');
    const bearer = sessionStorage.getItem('chave') || '{}';
    const stKey = this.userLoged.company.stKey.toString();
    this.gixData = apiGixget(idUser, bearer, stKey);
    this.dataPenalty = await getPenalty(this.territory.id);
    if (this.dataPenalty.length !== 0) {
      this.penaltyPageButton = true;
    }
    this.dataCdTerritory.cdTerritory = this.territory.id;
    // await this.appointmentRequest();
    this.actData = await getAct(company.stKey, this.territory.id);
    const reduced = [];
    this.actData.objectResult.forEach((item: any) => {
      const duplicated = reduced.findIndex((redItem) => {
        // @ts-ignore
        return item?.act === redItem?.act;
      }) > -1;
      if (!duplicated) {
        // @ts-ignore
        reduced.push(item);
      }
    });
    this.actDataResult = reduced;
    this.tickets = await getTickets({ cdTerritory: this.territory.id });
    this.convertDateActsArray();
    this.convertDataTicketsArray();
    this.gixData.then((e) => {
      this.objAct = e.data.objectResult;
    });
    // await this.appointmentRequest();
    this.getReportRequest();
    // @ts-ignore
    this.force = '';
    this.verifyPenalty();
    this.getLinkDocumentTermCommitment();
  },
});
